<template functional>
  <div
    class="title-row d-flex flex-column flex-md-row justify-md-space-between align-start"
  >
    <ebsn-meta
      :target="props.config"
      :path="`categoryblocktype_${props.categoryBlockName}.TITLE`"
      tag="h2"
      cssClass="slider-title font-weight-bold mr-3"
    />
    <v-btn
      v-if="
        props.showMore &&
          !parent.$ebsn.meta(
            props.config,
            'categoryblocktype_' + props.categoryBlockName + '.HIDE_LINK'
          )
      "
      color="primary"
      depressed
      class="align-self-end align-self-md-center mx-3"
      :to="
        $options.calcLinkToGo(
          props.config,
          props.categoryBlockName,
          parent.$ebsn.meta
        )
      "
    >
      {{
        parent.$ebsn.meta(
          props.config,
          "categoryblocktype_" + props.categoryBlockName + ".BUTTON_TEXT",
          parent.$t("categoryBlock.productListSlider.showAll")
        )
      }}
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "TitleRow",
  props: {
    config: { type: Object, required: true },
    categoryBlockName: { type: String, required: true },
    showMore: { type: Boolean, default: false }
  },
  calcLinkToGo(config, categoryBlockName, getMetaFunction) {
    let categorySlug = getMetaFunction(
      config,
      "categoryblocktype_" + categoryBlockName + ".CATEGORY.slug"
    );
    if (categorySlug) {
      return {
        name: "Category",
        params: {
          pathMatch: categorySlug
        }
      };
    } else {
      return getMetaFunction(
        config,
        "categoryblocktype_" + categoryBlockName + ".LINK"
      );
    }
  }
};
</script>
